var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("PortfolioFilter", {
        attrs: { total: _vm.items.length, filters: _vm.filters },
        on: { filter: _vm.filterElements }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "projects" },
        _vm._l(_vm.items, function(item) {
          return _vm.loaded && _vm.showItem(item)
            ? _c("Item", {
                key: item.id,
                attrs: {
                  link: item.link,
                  title: item.title.rendered,
                  image: item.acf.image.sizes.thumb_415x415,
                  filters: _vm.getItemFilters(item)
                }
              })
            : _vm._e()
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }